import React from 'react';

export function StatusBadge({ status }) {
  const labels = {
    waiting: 'Waiting',
    'in-progress': 'In Progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
  };
  return <span className={`badge badge-${status}`}>{labels[status] || status}</span>;
}

export function PaymentBadge({ status }) {
  // DB stores 'unpaid'; we display "Pending" everywhere in the UI
  // so staff understand it means "still to be collected", not "never paid".
  const labels = {
    paid:    'Paid',
    unpaid:  'Pending',
    partial: 'Partial',
  };
  return <span className={`badge badge-${status}`}>{labels[status] || status}</span>;
}
